import { DashboardSmartView } from '../gzDashboardSmartViewsList/types';

export enum ViewType {
  DEFAULT = 0,
  CUSTOM = 1,
}

export interface Dashboard {
  id: string;
  name: string;
  views: Array<DashboardSmartView>;
}

export enum DashboardsReduxActions {
  CHANGE_ACTIVE_SMART_VIEW = 'dashboardsApp/viewsSlice/changeActiveSmartView',
  RENAME_SMART_VIEW = 'dashboardsApp/viewsSlice//renameSmartView',
  TOGGLE_IS_OPEN_STATE_FOR_SMART_VIEWS_CATEGORY = 'dashboardsApp/viewsSlice/toggleIsOpenStateForSmartViewsCategory',
  EXPAND_ACTIVE_SMART_VIEW_CATEGORY = 'dashboardsApp/viewsSlice/expandActiveSmartViewCategory',
  TOGGLE_SMART_VIEWS_PANEL_COLLAPSED_STATE = 'dashboardsApp/viewsSlice/toggleSmartViewsPanelCollapsedState',
  GET_SMART_VIEWS_CATEGORIES = 'dashboardsApp/viewsSlice/getSmartViewsCategories',
  SET_SMART_VIEWS_CATEGORIES = 'dashboardsApp/viewsSlice/setSmartViewsCategories',
  GET_SMART_VIEWS = 'dashboardsApp/viewsSlice/getSmartViews',
  SET_SMART_VIEWS = 'dashboardsApp/viewsSlice/setSmartViews',
  DELETE_SMART_VIEW = 'dashboardsApp/viewsSlice/deleteSmartView',
  SAVE_SMART_VIEW_CONFIGURATION = 'dashboardsApp/viewsSlice/saveSmartViewConfiguration',
  CREATE_NEW_SMART_VIEW_CONFIGURATION = 'dashboardsApp/viewsSlice/createNewSmartViewConfiguration',
  DISCARD_SMART_VIEW_CHANGES_ASYNC = 'dashboardsApp/viewsSlice/discardSmartViewChangesAsync',
  DISCARD_SMART_VIEW_CHANGES = 'dashboardsApp/viewsSlice/discardSmartViewChanges',
  UPDATE_SMART_VIEWS_SEARCH_TEXT = 'dashboardsApp/viewsSlice/updateSmartViewsSearchText',
  TOGGLE_SMART_VIEW_HAS_UNSAVED_CHANGES = 'dashboardsApp/viewsSlice/toggleSmartViewHasUnsavedChanges',
  RESET_VIEW = 'dashboardsApp/viewsSlice/resetView',
  TOGGLE_LIVE_VIEW = 'dashboardsApp/uiSlice/toggleLiveView',
  TOGGLE_FULLSCREEN = 'dashboardsApp/uiSlice/toggleFullscreen',
  TOGGLE_SETTINGS_PANEL = 'dashboardsApp/uiSlice/toggleSettingsPanel',
  TOGGLE_WIDGET_DETAILS_PANEL = 'dashboardsApp/uiSlice/toggleWidgetDetailsPanel',
  TOGGLE_FILTERS_PANEL = 'dashboardsApp/uiSlice/toggleFiltersPanel',
  SET_DASHBOARD_CONFIGURATION = 'dashboardsApp/uiSlice/setDashboardConfiguration',
  DISABLE_LIVE_VIEW_FUNCTIONALITY = 'dashboardsApp/uiSlice/disableLiveViewFunctionality',
  SET_DASHBOARD_FILTERS = 'dashboardsApp/filtersSlice/setFilters',
  RESET_FILTERS = 'dashboardsApp/filtersSLice/resetFilters',
  GET_WIDGETS_CATEGORIES = 'dashboardsApp/widgetsSlice/getWidgetsCategories',
  SET_WIDGETS_CATEGORIES = 'dashboardsApp/widgetsSlice/setWidgetsCategories',
  GET_WIDGETS = 'dashboardsApp/widgetsSlice/getWidgets',
  UPDATE_WIDGETS_SEARCH_TEXT = 'dashboardsApp/widgetsSlice/updateWidgetsSearchText',
  SET_REFRESH_WIDGETS = 'dashboardsApp/widgetsSlice/setRefreshWidgets',
  MARK_WIDGET_INACTIVE = 'dashboardsApp/widgetsSlice/markWidgetInactive',
  TOGGLE_COLLAPSED_STATE_FOR_WIDGETS_CATEGORY = 'dashboardsApp/widgetsSlice/toggleCollapsedStateForWidgetsCategory',
  UPDATE_WIDGET = 'dashboardsApp/widgetsSlice/updateWidget',
  SET_WIDGETS = 'dashboardsApp/widgetsSlice/setWidgets',
  RESET_WIDGETS = 'dashboardsApp/widgetsSlice/resetWidgets',
  UPDATE_WIDGETS_CONFIGS = 'dashboardsApp/widgetsSlice/updateWidgetsConfigs',
  UPDATE_SETTINGS_PANEL_WIDGETS_ACTIVE_STATE = 'dashboardsApp/widgetsSlice/updateSettingsPanelWidgetsActiveState',
  UPDATE_SETTINGS_PANEL_WIDGETS_ACTIVE2_STATE = 'dashboardsApp/widgetsSlice/updateSettingsPanelWidgetsActive2State',
  SET_RESET_GRID_STACK = 'dashboardsApp/viewsSlice/resetGridStack',
  SET_BULK_INITIAL_STATE = 'dashboardsApp/setBulkInitialState',
  TOGGLE_EXPORT_BUTTON_SPINNER = 'dashboardsApp/toggleExportButtonSpinner',
  TOGGLE_HAS_WIDGETS_IN_ERROR_STATE = 'dashboardsApp/toggleHasWidgetsInErrorState',
}

export enum DashboardEventsListeners {
  WIDGET_DETAILS_CLICKED = 'widget-details-clicked',
  CLOSE_WIDGET_DETAILS = 'close-widget-details',
}
